import { render, staticRenderFns } from "./SettingsMarkets.vue?vue&type=template&id=29b6b8c2&"
import script from "./SettingsMarkets.vue?vue&type=script&lang=js&"
export * from "./SettingsMarkets.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMarkets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports